import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import "./AssignDetailsForm.css";

const styles_buttons = theme => ({
  radio: {
      color: '#0070A2',
      '&$checked': {
          color: '#0070A2',
        },
      height : '35px',
  },
  checked: {},
  label : {
    color: '#697882',
    fontSize: 15,
    fontFamily: 'Helvetica',
  },
  root: {
    display: 'flex',
},
});

class AssignDetailsForm extends React.Component {
  state = {
    value: '',
  };

  handleChange = event => {
    this.setState({ value: event.target.value });
    this.props.onRadioSelection(event)
  };

  render() {
    const { classes, values, labels } = this.props;
    return (
      
      <FormControl component="fieldset" className="d-flex justify-content-around">
        <RadioGroup
          name={this.props.name}
          value={this.state.value}
          onChange={this.handleChange}
          row
          className="d-flex justify-content-around"
        >
          <FormControlLabel
            value={values[0]}
            control={<Radio classes={{root : classes.radio, checked : classes.checked}} />}
            label={labels[0]}
            labelPlacement="bottom"
            classes = {{label : classes.label}}
          />
          <FormControlLabel
            value={values[1]}
            control={<Radio classes={{root : classes.radio, checked : classes.checked}} />}
            label={labels[1]}
            labelPlacement="bottom"
            classes = {{label : classes.label}}
          />
          <FormControlLabel
            value={values[2]}
            control={<Radio classes={{root : classes.radio, checked : classes.checked}} />}
            label={labels[2]}
            labelPlacement="bottom"
            classes = {{label : classes.label}}
          />
        </RadioGroup>
      </FormControl>
      
    );
  }
}

AssignDetailsForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles_buttons)(AssignDetailsForm);